import React, { Fragment, useCallback } from 'react';
import PropTypes from 'prop-types';

import { translate } from 'services/i18nService';
import Button from 'components/Button/Button';

import Cam4Logo from '../components/Cam4Logo';
import BadgesSection from '../components/BadgesSection';
import AgeConsentSection from '../components/AgeConsentSection';
import CooperationSection from '../components/CooperationSection';

import styles from './index.css';
import { IDS } from './constants';


function DisclaimerWithAgeVerification({ onAccept, onReject }) {
  const onClick = useCallback(() => onAccept(''), [onAccept]);

  return (
    <Fragment>
      <Cam4Logo />
      <p className={styles.ofAge}>{translate('disclaimer.age.consent.over.18')}</p>
      <BadgesSection />
      <div className={styles.legalContainer}>
        <AgeConsentSection />
        <CooperationSection />
      </div>

      <div className={styles.btnsContainer}>
        <Button
          className={styles.exitBtn}
          colour="white"
          id={IDS.exitBtn}
          onClick={onReject}
        >
          {translate('disclaimer.disclaimer.exit')}
        </Button>
        <Button
          className={styles.agreeBtn}
          colour="orange"
          id={IDS.agreeBtn}
          onClick={onClick}
        >
          {translate('disclaimer.disclaimer.agree')}
        </Button>
      </div>
    </Fragment>
  );
}

DisclaimerWithAgeVerification.propTypes = {
  onAccept: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired,
};

export default DisclaimerWithAgeVerification;
